class @App.Pages.AdditionalInformation
  $document = $(document)
  formId = '#additional-information'
  form = $(formId).parsley()
  $submit = $(formId).find('[type="submit"]')
  userTypeField = 'input[name="user[user_type_cd]"]'

  constructor: ->
    @bindElements()
    @toggleRelatedFields($("#{userTypeField}:checked").val() || -1)
    $submit.attr "disabled", "disabled" if !form.isValid()
    return

  bindElements: ->
    $document.on 'change', userTypeField, (e) =>
      @toggleRelatedFields($(e.currentTarget).val())

    $document.on 'change', "#{formId} input", (e) ->
      if form.isValid()
        $submit.removeAttr "disabled"
      else
        $submit.attr "disabled", "disabled"

  toggleRelatedFields: (userType) ->
    allFields = "[data-show-usertype]"
    activeFields = "[data-show-usertype='#{userType}']"
    $(document).find(allFields).hide()
    $(document).find("#{allFields} input").prop("disabled", true)
    $(document).find(activeFields).show()
    $(document).find("#{activeFields} input").prop("disabled", false)

$(document).on 'turbo:load', ->
  if $(document.body).hasClass('usersAdditionalInformationView')
    new App.Pages.AdditionalInformation
